import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid } from '@material-ui/core';
import Button from 'on_web/components/shared/Common/Button';
import { DownloadIcon } from 'on_web/assets/iconsList';
import { Typography } from '@material-ui/core';
import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';
import AssessmentSectionTitle from 'on_web/components/shared/AssessmentSectionTitle/AssessmentSectionTitle';

export default function RiskReportCard(props) {
  return (
    <>
      <AssessmentSectionTitle isDesktop={props.isDesktop} title={props.title} />
      <Box
        style={{
          paddingLeft: '20px',
          paddingRight: '20px',
          paddingBottom: '20px',
          marginTop: '14px',
          borderBottom: '1px Solid #efefef',
        }}
      >
        <Grid
          container
          style={{ paddingTop: '17px' }}
          direction="row"
          justify="flex-start"
          alignItems="center"
        >
          <Grid item xs={12} md={props.downloadUrl ? 6 : 12}>
            <Grid container>
              <Grid item xs={4}>
                <Box display="flex">
                  <Box>{props.icon}</Box>
                </Box>
              </Grid>
              <Grid item xs={8}>
                <Box>
                  <Typography
                    variant="h5"
                    style={{
                      fontSize: props.isDesktop ? '16px' : '15.5px',
                    }}
                  >
                    {props.downloadUrl
                      ? props.downloadText
                      : props.generatingText}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          {props.downloadUrl && (
            <Grid item xs={12} md={6}>
              <Box display="flex" justifyContent="center">
                <Box paddingTop={{ xs: 2, sm: 0 }}>
                  <Button
                    endIcon={<DownloadIcon height={17} />}
                    variant="contained"
                    color="primary"
                    backgroundGradient={
                      'linear-gradient(to right, #194378, #30eaff)'
                    }
                    style={{
                      paddingLeft: '25px',
                      paddingRight: '25px',
                      paddingTop: '10px',
                      paddingBottom: '10px',
                      fontSize: '11px',
                    }}
                    onClick={() => {
                      trackEvent('Reporting', 'Downloaded report');
                      window.open(props.downloadUrl, '_blank');
                    }}
                  >
                    {props.buttonText.toUpperCase()}
                  </Button>
                </Box>
              </Box>
            </Grid>
          )}
        </Grid>
      </Box>
    </>
  );
}

RiskReportCard.propTypes = {
  /**
   * Report icon.
   */
  icon: PropTypes.string.isRequired,

  /**
   * Text to be displayed when download is ready.
   */
  downloadText: PropTypes.string.isRequired,

  /**
   * Text to be displayed while download is not yet ready.
   */
  generatingText: PropTypes.string.isRequired,

  /**
   * Text on download button.
   */
  buttonText: PropTypes.string.isRequired,

  /**
   * URL to report.
   */
  downloadUrl: PropTypes.string.isRequired,

  /**
   * Indicates whether used resolution is for desktop.
   */
  isDesktop: PropTypes.bool.isRequired,
};
